import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

const className = classnames(
  'flex',
  'flex-row',
  'justify-center',
  'items-center',
  'place-items-center',
  'cursor-pointer',
  'py-1.5',
  'px-3'
);

interface Props {
  children: string;
  icon?: Icon;
}

const CardTextIcon = ({ children, icon }: Props) => (
  <div className={className}>
    <div className="flex items-center pr-2">
      <IconView icon={icon} size={'lg'} />
    </div>
    <div>{children}</div>
  </div>
);

export default CardTextIcon;
